import classNames from 'classnames';
import { Reference, ReferenceProps } from './reference.js';

export type ReferenceTypeProps = { attribution?: ReferenceProps; classes?: string };
/** Used with tile components to reference third party */
export const ReferenceTile = ({ attribution = {}, classes }: ReferenceTypeProps) => {
  if (attribution?.image || attribution?.text) {
    return (
      <div data-comp="reference-tile" className={classNames(`Tile-body u-textGrey fineprint u-textCenter`, classes)}>
        <Reference {...attribution} maxHeight={attribution.maxHeight ?? 1.5} center={attribution.center ?? true} />
      </div>
    );
  }

  return null;
};
